// extracted by mini-css-extract-plugin
export default {"horizontalProductList":"HorizontalProductList_horizontalProductList__hUwh0","loading":"HorizontalProductList_loading__SOt0c","dragging":"HorizontalProductList_dragging__kyYor"};